import { useDragLayer, type XYCoord } from "react-dnd";
import Shift from "../Items/Shift";

const POINTER_INSET = 16;

const moreModalDragItems = new WeakMap<object, any>();

export const createMoreModalDragItem = <T extends object>(item: T, previewEvent: any): T => {
    moreModalDragItems.set(item, previewEvent);
    return item;
};

// Where this layer draws the preview's left edge - the source node sits in the closed modal, so
// its offset doesn't match what the user sees. Null for items that weren't dragged from the modal.
export const getMoreModalPreviewOffset = (item: object, clientOffset: XYCoord | null): XYCoord | null => {
    if (!clientOffset || !moreModalDragItems.has(item)) return null;
    return { x: clientOffset.x - POINTER_INSET, y: clientOffset.y };
};

function MoreModalDragLayer() {
    const { isDragging, item, clientOffset } = useDragLayer((monitor) => ({
        item: monitor.getItem(),
        clientOffset: monitor.getClientOffset(),
        isDragging: monitor.isDragging()
    }));

    const previewEvent = item ? moreModalDragItems.get(item) : null;
    if (!isDragging || !clientOffset || !previewEvent) {
        return null;
    }

    return (
        <div
            className="tw-fixed tw-top-0 tw-left-0 tw-z-50 tw-pointer-events-none tw-truncate tw-text-sm tw-leading-6 tw-opacity-90"
            style={{ width: 180, transform: `translate(${clientOffset.x - POINTER_INSET}px, ${clientOffset.y}px) translateY(-50%)` }}
        >
            <Shift event={previewEvent} />
        </div>
    );
}

export default MoreModalDragLayer;
